import { Controller } from "@hotwired/stimulus";

// Manages the webhook event picker: search/filter, select all, domain toggles, selected count.
export default class extends Controller {
  static targets = ["search", "event", "group", "count", "allToggle", "groupToggle"];

  connect() {
    this.updateCount();
  }

  // Filter events by search query
  filter() {
    const query = this.searchTarget.value.toLowerCase().trim();

    this.eventTargets.forEach((el) => {
      const name = el.dataset.eventName;
      el.classList.toggle("hidden", query !== "" && !name.includes(query));
    });

    // Hide empty groups
    this.groupTargets.forEach((group) => {
      const visibleEvents = group.querySelectorAll(
        '[data-webhook-events-target="event"]:not(.hidden)'
      );
      group.classList.toggle("hidden", visibleEvents.length === 0);
    });
  }

  // Toggle all events on/off
  toggleAll() {
    const checked = this.allToggleTarget.checked;
    this.eventTargets.forEach((el) => {
      const checkbox = el.querySelector('input[type="checkbox"]');
      if (checkbox) checkbox.checked = checked;
    });
    this.updateGroupToggles();
    this.updateCount();
  }

  // Toggle all events in a domain group
  toggleGroup(e) {
    const domain = e.currentTarget.dataset.domain;
    const checked = e.currentTarget.checked;
    const group = this.groupTargets.find((g) => g.dataset.domain === domain);
    if (!group) return;

    group
      .querySelectorAll('input[type="checkbox"][name*="event_subscriptions"]')
      .forEach((cb) => {
        cb.checked = checked;
      });

    this.updateAllToggle();
    this.updateCount();
  }

  // Individual event toggled
  toggle() {
    this.updateGroupToggles();
    this.updateAllToggle();
    this.updateCount();
  }

  updateCount() {
    const checked = this.checkedEvents();
    const total = this.eventTargets.length;
    this.countTarget.textContent =
      checked.length === total
        ? "All events"
        : `${checked.length} of ${total} events`;

    // Sync the "all" toggle
    if (this.hasAllToggleTarget) {
      this.allToggleTarget.checked = checked.length === total;
    }
  }

  updateGroupToggles() {
    this.groupToggleTargets.forEach((toggle) => {
      const domain = toggle.dataset.domain;
      const group = this.groupTargets.find((g) => g.dataset.domain === domain);
      if (!group) return;

      const checkboxes = group.querySelectorAll(
        'input[type="checkbox"][name*="event_subscriptions"]'
      );
      const allChecked = [...checkboxes].every((cb) => cb.checked);
      toggle.checked = allChecked;
    });
  }

  updateAllToggle() {
    if (!this.hasAllToggleTarget) return;
    const checked = this.checkedEvents();
    this.allToggleTarget.checked = checked.length === this.eventTargets.length;
  }

  checkedEvents() {
    return this.eventTargets.filter((el) => {
      const cb = el.querySelector('input[type="checkbox"]');
      return cb && cb.checked;
    });
  }

  // Expand/collapse a domain group
  expandGroup(e) {
    const domain = e.currentTarget.dataset.domain;
    const group = this.groupTargets.find((g) => g.dataset.domain === domain);
    if (!group) return;

    const list = group.querySelector("[data-event-list]");
    const icon = e.currentTarget.querySelector("[data-chevron]");
    if (list) list.classList.toggle("hidden");
    if (icon) icon.classList.toggle("rotate-90");
  }
}
